import { React } from 'react';
import { Input, Button, Icon, Grid, Progress, Label, Modal, List, ListHeader, Message } from 'semantic-ui-react';
import axios from 'axios';
import axiosCustom from '../../utils/axiosCustom';
import { resetProjectListWithDetail, setDataToExport, setProjects } from '../../redux/projectSlice';
import { loadingEnd, loadingStart, setAvancement, setSearchValue, showMenuXLS, showMenuPDF, setError, setMsgAlert, resetError } from '../../redux/appSlice';
import { useDispatch, useSelector } from 'react-redux'
import XLSX from 'sheetjs-style'
import FileSaver from 'file-saver'

const cols = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  'AA',
  'AB',
  'AC',
  'AD',
  'AE',
  'AF',
  'AG',
  'AH',
  'AI',
  'AJ',
  'AK',
  'AL'
];
const workSheets = [
  'Step 1 All partners',
  'Step 2 All partners',
  'Step 1 Projects',
  'Step 2 Projects',
  'Step 1 summaries',
  'Step 2 summaries',
  'Solvency Check',
  'Overview Of Submitted Projects',
  'Overview Of Submitted Projects',
  'Overview Of Submitted Projects',
  'Overview Of Submitted Projects',
  'Overview Of Submitted Projects',
  'Overview Of Submitted Projects',
  'Overview Of Submitted Projects',
  'Overview Of Submitted Projects',
  'Overview Of Submitted Projects'
];
const styles = {
  header: {
    font: {
      bold: true,
    },
    alignment: {
      horizontal: 'center',
      vertical: 'top'
    }
  },
  headerOverview: {
    font: {
      bold: true,
      color: { rgb: 'FFFFFF' },
      sz: 10,
      name: 'Open Sans Semibold'
    },
    alignment: {
      horizontal: 'center',
      vertical: 'center'
    },
    fill: {
      fgColor: { rgb: '2E5C9A' }
    }
  },
  center: {
    alignment: {
      horizontal: 'center',
      vertical: 'top'
    },
    font: {
      name: 'Open Sans',
      sz: 10
    }
  },
  financial: {
    numFmt: '#,##0.00',
    alignment: {
      vertical: 'top'
    },
    font: {
      name: 'Open Sans',
      sz: 10
    }
  },
  default: {
    alignment: {
      vertical: 'top',
    },
    font: {
      name: 'Open Sans',
      sz: 10
    }
  },
  colored: {
    fill: {
      pattern: 'solid',
      fgColor: { rgb: '9EBBE2' }
    }
  },
  coloredLight: {
    fill: {
      pattern: 'solid',
      fgColor: { rgb: 'CEDDF0' }
    }
  },
  coloredDark: {
    fill: {
      pattern: 'solid',
      fgColor: { rgb: '2E5C9A' }
    },
    font: {
      color: { rgb: 'FFFFFF' }
    }
  }
};



const stylesToApply = [
  { cols: ['F', 'G', 'H', 'AB'], style: styles.center },
  { cols: ['F', 'G', 'H', 'AH'], style: styles.center },
  { cols: ['G', 'H', 'I', 'S'], style: styles.center },
  { cols: ['I', 'J', 'K', 'U'], style: styles.center },
  { cols: ['J', 'K', 'L'], style: styles.center },
  { cols: ['J', 'K', 'L'], style: styles.center },
  { cols: ['E'], style: styles.center },
  { cols: ['C', 'D', 'E'], style: styles.center },
  { cols: ['C', 'D', 'E'], style: styles.center },
  { cols: ['C', 'D', 'E'], style: styles.center },
  { cols: ['C', 'D', 'E'], style: styles.center },
  { cols: ['C', 'D', 'E'], style: styles.center },
  { cols: ['C', 'D', 'E'], style: styles.center },
  { cols: ['C', 'D', 'E'], style: styles.center },
  { cols: ['C', 'D', 'E'], style: styles.center },
  { cols: ['C', 'D', 'E'], style: styles.center }
]

const financialStyles = [
  { cols: [], style: styles.financial },
  { cols: ['AD', 'AF', 'AG'], style: styles.financial },
  { cols: ['N', 'O', 'P'], style: styles.financial },
  { cols: ['N', 'O'], style: styles.financial },
  { cols: [], style: styles.financial },
  { cols: ['O', 'P'], style: styles.financial },
  { cols: [], style: styles.financial },
  { cols: ['G', 'H', 'I'], style: styles.financial },
  { cols: ['G', 'H', 'I'], style: styles.financial },
  { cols: ['G', 'H', 'I'], style: styles.financial },
  { cols: ['G', 'H', 'I'], style: styles.financial },
  { cols: ['G', 'H', 'I'], style: styles.financial },
  { cols: ['G', 'H', 'I'], style: styles.financial },
  { cols: ['G', 'H', 'I'], style: styles.financial },
  { cols: ['G', 'H', 'I'], style: styles.financial },
  { cols: ['G', 'H', 'I'], style: styles.financial }
]
//console.warn(data);
const headersWs = [
  [
    'Call number',
    'Project number',
    'Project status',
    'Acronym',
    'Title',
    'Priority',
    'S.O',
    'Partner number',
    'Partner name',
    'Abbreviation',
    'Role',
    'Type of partner',
    'Legal status',
    'Legal representative',
    'Country',
    'NUTS2',
    'NUTS3',
    'Street',
    'House number',
    'Postal code',
    'City',
    'Address line 1',
    'Address line 2',
    'Address country',
    'Partner contact person',
    'Partner contact email',
    'Partner contact person telephone',
    'AF annexes',
    'AF annexes file names'
  ],
  [
    'Call number',
    'Project number',
    'Project status',
    'Acronym',
    'Title',
    'Priority',
    'S.O',
    'Partner number',
    'Partner name',
    'Abbreviation',
    'Role',
    'Type of partner',
    'Partner size',
    'Legal status',
    'Legal representative',
    'Applies for an advance ?',
    'Country',
    'NUTS2',
    'NUTS3',
    'Street',
    'House number',
    'Postal code',
    'City',
    'Address line 1',
    'Address line 2',
    'Address country',
    'Partner contact person',
    'Partner contact email',
    'Partner contact person telephone',
    'Partner TEC budget',
    'ERDF grant rate',
    'Partner ERDF budget',
    'Calculated advance',
    'AF annexes',
    'AF annexes file names'
  ],
  [
    'Call number',
    'Project number',
    'Project status',
    'Acronym',
    'Title',
    'Summary',
    'Duration',
    'Priority',
    'S.O',
    'LP name',
    'LP country',
    'NUTS2',
    'NUTS3',
    'Project TEC',
    'Project ERDF',
    '% for investment',
    'AF author',
    'Author\'s email address',
    'AF annexes',
    'AF annexes file names'
  ],
  [
    'Call number',
    'Project number',
    'Project status',
    'Acronym',
    'Title',
    'Summary',
    'Start date',
    'End date',
    'Duration',
    'Priority',
    'S.O',
    'LP name',
    'LP country',
    'NUTS2',
    'NUTS3',
    'Project TEC',
    'Project ERDF',
    'Grant rate',
    'AF author',
    'Author\'s email address',
    'AF annexes',
    'AF annexes file names'
  ],
  [
    'Call number',
    'Project number',
    'Project status',
    'Acronym',
    'Title',
    'Summary in English',
    'Summary in French',
    'Summary in German',
    'Summary in Dutch',
    'Duration',
    'Priority',
    'S.O',
    'LP name',
    'LP country'
  ],
  [
    'Call number',
    'Project number',
    'Project status',
    'Acronym',
    'Title',
    'Summary in English',
    'Summary in French',
    'Summary in German',
    'Summary in Dutch',
    'Duration',
    'Priority',
    'S.O',
    'LP name',
    'LP country',
    'Project TEC',
    'Project ERDF'
  ],
  [
    'Call number',
    'Project number',
    'Project status',
    'Acronym',
    'Partner number',
    'Partner name',
    'Abbreviation',
    'Role',
    'Type of partner',
    'Legal status',
    'Country',
    'NUTS2',
    'Is solvency documentation required?',
    'Financial statement n-2',
    'Financial statement n-1',
    'Excerpt from company registry'
  ],
  [ // Call 1 Step 1
    'Project number',
    'Acronym',
    'Duration',
    'Priority',
    'S.O.',
    'LP country',
    'Project TEC',
    'Project ERDF',
    'Grant rate'
  ],
  [ // Call 1 Step 2
    'Project number',
    'Acronym',
    'Duration',
    'Priority',
    'S.O.',
    'LP country',
    'Project TEC',
    'Project ERDF',
    'Grant rate'
  ],
  [ // Call 2 Step 1
    'Project number',
    'Acronym',
    'Duration',
    'Priority',
    'S.O.',
    'LP country',
    'Project TEC',
    'Project ERDF',
    'Grant rate'
  ],
  [ // Call 2 Step 2
    'Project number',
    'Acronym',
    'Duration',
    'Priority',
    'S.O.',
    'LP country',
    'Project TEC',
    'Project ERDF',
    'Grant rate'
  ],
  [ // Call 3 Step 2
    'Project number',
    'Acronym',
    'Duration',
    'Priority',
    'S.O.',
    'LP country',
    'Project TEC',
    'Project ERDF',
    'Grant rate'
  ],
  [ // Call 4 Step 1
    'Project number',
    'Acronym',
    'Duration',
    'Priority',
    'S.O.',
    'LP country',
    'Project TEC',
    'Project ERDF',
    'Grant rate'
  ],
  [ // Call 4 Step 2
    'Project number',
    'Acronym',
    'Duration',
    'Priority',
    'S.O.',
    'LP country',
    'Project TEC',
    'Project ERDF',
    'Grant rate'
  ],
  [ // Call 5 Step 1
    'Project number',
    'Acronym',
    'Duration',
    'Priority',
    'S.O.',
    'LP country',
    'Project TEC',
    'Project ERDF',
    'Grant rate'
  ],
  [ // Call 5 Step 2
    'Project number',
    'Acronym',
    'Duration',
    'Priority',
    'S.O.',
    'LP country',
    'Project TEC',
    'Project ERDF',
    'Grant rate'
  ],
];

const Recherche = () => {
  const dispatch = useDispatch();
  const appState = useSelector(state => state.app);
  const projectState = useSelector(state => state.project);

  const onSearchChange = (e, data) => {
    dispatch(setSearchValue(data.value.toUpperCase()));
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSearch(appState.searchValue);
    }
  }

  const onSearch = async (searchValue) => {
    try {
      dispatch(showMenuPDF(false));
      const API_URL = process.env.REACT_APP_BASE_API_URL;
      const options = {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
      const res = await axios.post(API_URL + '/project/list', {}, options)
      if (res.status === 200) {
        const AllProject = res.data.content
        const foundProject = AllProject.filter(project => project.customIdentifier.includes(searchValue) || project.acronym.toUpperCase().includes(searchValue))
        dispatch(setProjects(foundProject));
      }
      else {
        console.error('error');
      }
    } catch (e) {
      //console.log(e);
    }
  }


  const exportProjectInvestments = async () => {
    let projectList = [];
    try {
      dispatch(resetError());
      dispatch(loadingStart());
      //dispatch(resetProjectListWithDetail());

      const API_URL = process.env.REACT_APP_BASE_API_URL;
      const options = {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      }

      const res = await axios.post(API_URL + '/project/list', {
        //statuses: ['RETURNED_TO_APPLICANT_FOR_CONDITIONS','APPROVED','CONDITIONS_SUBMITTED']
        //statuses: ['DRAFT']
        //id: '403'
      }, options)

      if (res.status === 200) {
        const AllProject = res.data.content
        console.time('getAllData');
        for (let [index, element] of AllProject.entries()) {
          const avancement = {};
          avancement.nb = index + 1;
          avancement.total = AllProject.length;
          dispatch(setAvancement(avancement));
          let promises = [];
          let projectDetail = element;
          try {
            const [workPackages, partners] = await Promise.all([
              axiosCustom.get(API_URL + '/project/' + element.id + '/workPackage', options),
              axiosCustom.get(API_URL + '/project/partner/byProjectId/' + element.id + '/ids', options),
            ]);

            workPackages.forEach(workPackage => {
              promises.push(axiosCustom.get(API_URL + '/project/' + element.id + '/workPackage/' + workPackage.id + '/investment', options).then(res => {
                workPackage.investments = res;
              }));
            });

            partners.forEach(partner => {
              promises.push(axiosCustom.get(API_URL + '/project/partner/' + partner.id + '/budget/costs', options).then(res => {
                partner.costs = res;
              }));
            });

            projectDetail.workPackages = workPackages;
            projectDetail.partners = partners;
            projectList.push(projectDetail);
          } catch (error) {
            console.error(error);
          }
        }
      } else {
        console.error('Cannot get projects list');
      }
    } catch (error) {
      console.error(error);
    }
    //console.warn(projectList);

    dispatch(loadingEnd());
    const dataInvestments = convertDataToXlsProjectInvestments(projectList);
    exportXlsxProjectInvestments(dataInvestments);

  }

  const getAllData = async () => {
    let projectList = [];
    try {
      dispatch(resetError());
      dispatch(loadingStart());
      dispatch(resetProjectListWithDetail());

      const API_URL = process.env.REACT_APP_BASE_API_URL;
      const options = {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      }
      
      console.log('getAllData', options);

      const res = await axios.post(API_URL + '/project/list', {
        //statuses: ['RETURNED_TO_APPLICANT_FOR_CONDITIONS','APPROVED','CONDITIONS_SUBMITTED']
        //statuses: ['STEP1_DRAFT']
        // id: '403'
      }, options)
      if (res.status === 200) {
        const AllProject = res.data.content
        console.time('getAllData');

        for (let [index, element] of AllProject.entries()) {

          const avancement = {};
          avancement.nb = index + 1;
          avancement.total = AllProject.length;
          dispatch(setAvancement(avancement));
          let projectDetail = element;
          try {
            let promises = []

            let checkListsDetails = []
            let partnersList = []

            let cofinancing;
            let projectFunds;

            const [resProject, resProjectApplicant, checklists, partners, projectFiles, workPackages, contractMonitoringPeriods, capCallData] = await Promise.all([
              axiosCustom.get(API_URL + '/project/byId/' + element.id + '/form', options),
              axiosCustom.get(API_URL + '/project/byId/' + element.id, options),
              axiosCustom.get(API_URL + '/checklist/instance/' + element.id + '/APPLICATION_FORM_ASSESSMENT/', options),
              axiosCustom.get(API_URL + '/project/partner/byProjectId/' + element.id + '/ids?sort=sortNumber', options),
              axiosCustom.get(API_URL + '/project/' + element.id + '/file', options),
              axiosCustom.get(API_URL + '/project/' + element.id + '/workPackage', options),
              axiosCustom.get(API_URL + '/project/' + element.id + '/contracting/monitoring/periods', options),
              axiosCustom.get(API_URL + '/project/cap-call?projectId=' + element.id, options),
            ]);

            promises.push(axiosCustom.get(API_URL + '/project/' + element.id + '/budget/perFund', options).then(res => {
              projectFunds = res;
            }));
            promises.push(axiosCustom.get(API_URL + '/project/' + element.id + '/coFinancingOverview', options).then(res => {
              cofinancing = res;
            }));

            checklists.forEach(checklist => {
              promises.push(axiosCustom.get(API_URL + '/checklist/instance/' + resProject.id + '/detail/' + checklist.id, options).then(res => {
                checklist.detail = res;
                checkListsDetails.push(checklist);
              }));
            });

            workPackages.forEach(workPackage => {
              promises.push(axiosCustom.get(API_URL + '/project/' + element.id + '/workPackage/' + workPackage.id + '/investment', options).then(res => {
                workPackage.investments = res;
              }));
            });


            partners.forEach(partner => {
              promises.push(Promise.all([
                axiosCustom.get(API_URL + '/project/partner/' + partner.id, options),
                axiosCustom.get(API_URL + '/project/partner/' + partner.id + '/budget/cofinancing', options),
                axiosCustom.get(API_URL + '/project/partner/' + partner.id + '/budget/total', options),
                axiosCustom.get(API_URL + '/project/' + element.id + '/file/' + partner.id, options)
              ]).then(res => {
                const [partnerData, partnerBudgetCofiData, partnerBudgetTotalData, partnerAttachments] = res;
                partnerData.sortNumber = partner.sortNumber
                partnerData.partnerNumber = (partner.role === 'LEAD_PARTNER' ? 'LP' : 'PP') + partner.sortNumber
                partnerData.budgetCofi = partnerBudgetCofiData;
                partnerData.budgetTotal = partnerBudgetTotalData;
                partnerData.attachments = partnerAttachments.content;
                //console.warn(partnerData);
                partnersList.push(partnerData);
              }));
            });

            await Promise.all(promises);
            console.warn('Project details :');
            console.warn(projectDetail);
            projectDetail.applicant = resProjectApplicant.applicant;
            projectDetail.checklistDetail = checkListsDetails;
            partnersList.sort((a, b) => a.sortNumber < b.sortNumber ? -1 : 1);
            projectDetail.partners = partnersList;
            projectDetail.details = resProject;
            projectDetail.cofinancing = cofinancing;
            projectDetail.funds = projectFunds;
            projectDetail.attachments = projectFiles.content;
            projectDetail.workPackages = workPackages;
            projectDetail.contractMonitoringPeriods = contractMonitoringPeriods;
            projectDetail.capCallPartnership = typeof capCallData.capPartnerShip === 'string' ? JSON.parse(capCallData.capPartnerShip) : capCallData.capPartnerShip;
            projectList.push(projectDetail);
          } catch (error) {
            console.error(error);
          }
        };

        console.timeEnd('getAllData');
        console.time('convertDataToXlsx');
        // console.warn(projectList);
        dispatch(loadingEnd());
        dispatch(showMenuXLS(true));

        let dataToExport = [];
        const dataPartner = convertDataToXlsxStep1Partners(projectList);
        const dataPartnerStep2 = convertDataToXlsxStep2Partners(projectList);
        const dataProjectStep1 = convertDataToXlsxStep1Projects(projectList);
        const dataProjectStep2 = convertDataToXlsxStep2Projects(projectList);
        const dataSummariesStep1 = convertDataToXlsxStep1Summaries(projectList);
        const dataSummariesStep2 = convertDataToXlsxStep2Summaries(projectList);
        const dataSolvencyCheck = convertDataToXlsxSolvencyCheck(projectList);
        const dataSubmittedProjectOverviewCall1Step1 = convertDataToXlsxSubmittedProjectsOverview(projectList, 1, ['STEP1_NOT_APPROVED', 'STEP1_SUBMITTED', 'STEP1_APPROVED', 'STEP1_INELIGIBLE', 'STEP1_ELIGIBLE', 'STEP1_APPROVED_WITH_CONDITIONS', 'RETURNED_TO_APPLICANT_FOR_CONDITIONS', 'RETURNED_TO_APPLICANT', 'SUBMITTED', 'APPROVED_WITH_CONDITIONS', 'APPROVED', 'CONTRACTED', 'ELIGIBLE', 'CONDITIONS_SUBMITTED', 'INELIGIBLE', 'NOT_APPROVED', 'DRAFT']);
        const dataSubmittedProjectOverviewCall1Step2 = convertDataToXlsxSubmittedProjectsOverview(projectList, 1, ['RETURNED_TO_APPLICANT_FOR_CONDITIONS', 'RETURNED_TO_APPLICANT', 'SUBMITTED', 'APPROVED_WITH_CONDITIONS', 'APPROVED', 'CONTRACTED', 'ELIGIBLE', 'CONDITIONS_SUBMITTED', 'INELIGIBLE', 'NOT_APPROVED']);
        const dataSubmittedProjectOverviewCall2Step1 = convertDataToXlsxSubmittedProjectsOverview(projectList, 2, ['STEP1_NOT_APPROVED', 'STEP1_SUBMITTED', 'STEP1_APPROVED', 'STEP1_INELIGIBLE', 'STEP1_ELIGIBLE', 'STEP1_APPROVED_WITH_CONDITIONS', 'RETURNED_TO_APPLICANT_FOR_CONDITIONS', 'RETURNED_TO_APPLICANT', 'SUBMITTED', 'APPROVED_WITH_CONDITIONS', 'APPROVED', 'CONTRACTED', 'ELIGIBLE', 'CONDITIONS_SUBMITTED', 'INELIGIBLE', 'NOT_APPROVED', 'DRAFT']);
        const dataSubmittedProjectOverviewCall2Step2 = convertDataToXlsxSubmittedProjectsOverview(projectList, 2, ['RETURNED_TO_APPLICANT_FOR_CONDITIONS', 'RETURNED_TO_APPLICANT', 'SUBMITTED', 'APPROVED_WITH_CONDITIONS', 'APPROVED', 'CONTRACTED', 'ELIGIBLE', 'CONDITIONS_SUBMITTED', 'INELIGIBLE', 'NOT_APPROVED']);
        const dataSubmittedProjectOverviewCall3Step2 = convertDataToXlsxSubmittedProjectsOverview(projectList, 3, ['RETURNED_TO_APPLICANT_FOR_CONDITIONS', 'RETURNED_TO_APPLICANT', 'SUBMITTED', 'APPROVED_WITH_CONDITIONS', 'APPROVED', 'CONTRACTED', 'ELIGIBLE', 'CONDITIONS_SUBMITTED', 'INELIGIBLE', 'NOT_APPROVED']);
        const dataSubmittedProjectOverviewCall4Step1 = convertDataToXlsxSubmittedProjectsOverview(projectList, 4, ['STEP1_NOT_APPROVED', 'STEP1_SUBMITTED', 'STEP1_APPROVED', 'STEP1_INELIGIBLE', 'STEP1_ELIGIBLE', 'STEP1_APPROVED_WITH_CONDITIONS', 'RETURNED_TO_APPLICANT_FOR_CONDITIONS', 'RETURNED_TO_APPLICANT', 'SUBMITTED', 'APPROVED_WITH_CONDITIONS', 'APPROVED', 'CONTRACTED', 'ELIGIBLE', 'CONDITIONS_SUBMITTED', 'INELIGIBLE', 'NOT_APPROVED', 'DRAFT']);
        const dataSubmittedProjectOverviewCall4Step2 = convertDataToXlsxSubmittedProjectsOverview(projectList, 4, ['RETURNED_TO_APPLICANT_FOR_CONDITIONS', 'RETURNED_TO_APPLICANT', 'SUBMITTED', 'APPROVED_WITH_CONDITIONS', 'APPROVED', 'CONTRACTED', 'ELIGIBLE', 'CONDITIONS_SUBMITTED', 'INELIGIBLE', 'NOT_APPROVED']);
        const dataSubmittedProjectOverviewCall5Step1 = convertDataToXlsxSubmittedProjectsOverview(projectList, 5, ['STEP1_NOT_APPROVED', 'STEP1_SUBMITTED', 'STEP1_APPROVED', 'STEP1_INELIGIBLE', 'STEP1_ELIGIBLE', 'STEP1_APPROVED_WITH_CONDITIONS', 'RETURNED_TO_APPLICANT_FOR_CONDITIONS', 'RETURNED_TO_APPLICANT', 'SUBMITTED', 'APPROVED_WITH_CONDITIONS', 'APPROVED', 'CONTRACTED', 'ELIGIBLE', 'CONDITIONS_SUBMITTED', 'INELIGIBLE', 'NOT_APPROVED', 'DRAFT']);
        const dataSubmittedProjectOverviewCall5Step2 = convertDataToXlsxSubmittedProjectsOverview(projectList, 5, ['RETURNED_TO_APPLICANT_FOR_CONDITIONS', 'RETURNED_TO_APPLICANT', 'SUBMITTED', 'APPROVED_WITH_CONDITIONS', 'APPROVED', 'CONTRACTED', 'ELIGIBLE', 'CONDITIONS_SUBMITTED', 'INELIGIBLE', 'NOT_APPROVED']);
        dataToExport.push(dataPartner);
        dataToExport.push(dataPartnerStep2);
        dataToExport.push(dataProjectStep1);
        dataToExport.push(dataProjectStep2);
        dataToExport.push(dataSummariesStep1);
        dataToExport.push(dataSummariesStep2);
        dataToExport.push(dataSolvencyCheck);
        dataToExport.push(dataSubmittedProjectOverviewCall1Step1); // Call 1 Step 1 >> 7
        dataToExport.push(dataSubmittedProjectOverviewCall1Step2); // Call 1 Step 2 >> 8
        dataToExport.push(dataSubmittedProjectOverviewCall2Step1); // Call 2 Step 1 >> 9
        dataToExport.push(dataSubmittedProjectOverviewCall2Step2); // Call 2 Step 2 >> 10
        dataToExport.push(dataSubmittedProjectOverviewCall3Step2); // Call 3 Step 2 >> 11
        dataToExport.push(dataSubmittedProjectOverviewCall4Step1); // Call 4 Step 1 >> 12
        dataToExport.push(dataSubmittedProjectOverviewCall4Step2); // Call 4 Step 2 >> 13
        dataToExport.push(dataSubmittedProjectOverviewCall5Step1); // Call 5 Step 1 >> 14
        dataToExport.push(dataSubmittedProjectOverviewCall5Step2); // Call 5 Step 2 >> 15

        dispatch(setDataToExport(dataToExport));
        console.timeEnd('convertDataToXlsx');
      }
      else {
        console.error('error');
      }
    } catch (e) {
      console.error(e);
    }
  }

  const formatUpperCaseString = (str) => {
    if (!str) return '';
    return str.replaceAll('_', ' ')
      .toLowerCase()
      .replace(/^\w/, (c) => c.toUpperCase());
  };

  const formatCamelCaseString = (str) => {
    if (!str) return '';

    let words = str.replaceAll(/([A-Z])/g, ' $1').trim().toLowerCase().split(' ');

    for (let i = 0; i < words.length; i++) {
      if (words[i].length <= 4 && words[i] !== 'and') {
        words[i] = words[i].toUpperCase();
      }
    }

    return words.join(' ').charAt(0).toUpperCase() + words.join(' ').slice(1);
  }

  const convertDataToXlsxStep1Partners = (data) => {
    //console.warn(data)
    let formattedDataStep1 = [];
    for (let element of data) {
      let partners = element.partners;
      for (let partner of partners) {
        let legalRepresentative = {};
        let contactPerson = {};
        for (let contact of partner.contacts) {
          if (contact.type === 'LegalRepresentative') {
            legalRepresentative.fullName = '';
            if (contact.title) legalRepresentative.fullName += contact.title + ' ';
            if (contact.firstName) legalRepresentative.fullName += contact.firstName + ' ';
            if (contact.lastName) legalRepresentative.fullName += contact.lastName;
          }
          if (contact.type === 'ContactPerson') {
            contactPerson.fullName = '';
            if (contact.title) contactPerson.fullName += contact.title + ' ';
            if (contact.firstName) contactPerson.fullName += contact.firstName + ' ';
            if (contact.lastName) contactPerson.fullName += contact.lastName;
            contactPerson.email = contact.email;
            contactPerson.telephone = contact.telephone;
          }
        }
        let row = {};
        row.callName = element.callName;
        row.customIdentifier = element.customIdentifier;
        //row.status = element.projectStatus;
        row.status = formatUpperCaseString(element.projectStatus);
        row.acronym = element.acronym;
        if (element.details.title[0] !== undefined) row.title = element.details.title[0].translation;
        row.priority = element.programmePriorityCode;
        row.so = element.specificObjectiveCode;
        row.partnerNumber = partner.sortNumber;
        row.partnerName = partner.nameInEnglish;
        row.partnerAbbreviation = partner.abbreviation;
        row.role = formatUpperCaseString(partner.role);
        row.partnerType = formatCamelCaseString(partner.partnerType);
        row.legalStatus = partner.legalStatusId === 1 ? 'Public' : 'Private';
        row.legalRepresentative = legalRepresentative.fullName;
        if (partner.addresses[0] !== undefined) {
          row.country = partner.addresses[0].country;
          row.nuts2 = partner.addresses[0].nutsRegion2;
          row.nuts3 = partner.addresses[0].nutsRegion3;
          row.street = partner.addresses[0].street;
          row.houseNumber = partner.addresses[0].houseNumber;
          row.postalCode = partner.addresses[0].postalCode;
          row.city = partner.addresses[0].city;
          row.addressLine1 = (row.houseNumber ? row.houseNumber + ' ' : '') + (row.street ? row.street : '');
          row.addressLine2 = (row.postalCode ? row.postalCode + ' ' : '') + (row.city ? row.city : '');
          if (partner.addresses[0].country) row.addressCountry = partner.addresses[0].country.split(' (')[0];
        }
        row.partnerContactPerson = contactPerson.fullName;
        row.partnerContactEmail = contactPerson.email;
        row.partnerContactTelephone = contactPerson.telephone;
        row.attachments = partner.attachments.length > 0 ? partner.attachments.length : 'No';
        row.attachmentsList = partner.attachments.map(attachment => attachment.name).join('; ');
        formattedDataStep1.push(row);
      }
    }
    formattedDataStep1.sort((a, b) => a.customIdentifier < b.customIdentifier ? -1 : 1);
    return formattedDataStep1;
  }

  const convertDataToXlsxStep2Partners = (data) => {
    console.log('convertDataToXlsxStep2Partners', data);
    let formattedDataStep2 = [];
    for (let element of data) {
      //console.warn(element);
      let partners = element.partners;
      let i = 0;
      for (let partner of partners) {
        let legalRepresentative = {};
        let contactPerson = {};
        for (let contact of partner.contacts) {
          if (contact.type === 'LegalRepresentative') {
            legalRepresentative.fullName = '';
            if (contact.title) legalRepresentative.fullName += contact.title + ' ';
            if (contact.firstName) legalRepresentative.fullName += contact.firstName + ' ';
            if (contact.lastName) legalRepresentative.fullName += contact.lastName;
          }
          if (contact.type === 'ContactPerson') {
            contactPerson.fullName = '';
            if (contact.title) contactPerson.fullName += contact.title + ' ';
            if (contact.firstName) contactPerson.fullName += contact.firstName + ' ';
            if (contact.lastName) contactPerson.fullName += contact.lastName;
            contactPerson.email = contact.email;
            contactPerson.telephone = contact.telephone;
          }
        }
        let row = {};
        row.callName = element.callName;
        row.customIdentifier = element.customIdentifier;
        row.status = formatUpperCaseString(element.projectStatus);
        row.acronym = element.acronym;
        if (element.details.title[0] !== undefined) row.title = element.details.title[0].translation;
        row.priority = element.programmePriorityCode;
        row.so = element.specificObjectiveCode;
        row.partnerNumber = partner.sortNumber;
        row.partnerName = partner.nameInEnglish;
        row.partnerAbbreviation = partner.abbreviation;
        row.role = formatUpperCaseString(partner.role);
        row.partnerType = formatCamelCaseString(partner.partnerType);
        row.partnerSize = formatUpperCaseString(partner.partnerSubType);
        row.legalStatus = partner.legalStatusId === 1 ? 'Public' : 'Private';
        row.legalRepresentative = legalRepresentative.fullName;
        row.applyForAdvance = partner.advance ? 'Yes' : 'No';
        if (partner.addresses[0] !== undefined) {
          row.country = partner.addresses[0].country;
          row.nuts2 = partner.addresses[0].nutsRegion2;
          row.nuts3 = partner.addresses[0].nutsRegion3;
          row.street = partner.addresses[0].street;
          row.houseNumber = partner.addresses[0].houseNumber;
          row.postalCode = partner.addresses[0].postalCode;
          row.city = partner.addresses[0].city;
          row.addressLine1 = (row.houseNumber ? row.houseNumber + ' ' : '') + (row.street ? row.street : '');
          row.addressLine2 = (row.postalCode ? row.postalCode + ' ' : '') + (row.city ? row.city : '');
          if (partner.addresses[0].country) row.addressCountry = partner.addresses[0].country.split(' (')[0];
        }

        row.partnerContactPerson = contactPerson.fullName;
        row.partnerContactEmail = contactPerson.email;
        row.partnerContactTelephone = contactPerson.telephone;
        row.partnerTECbudget = partner.budgetTotal;
        if (partner.budgetCofi && partner.budgetCofi.finances[0]) {
          // if (partner.budget.finances) {
          if (partner.budgetCofi.finances[0].percentage) {
            row.erdfGrantRate = partner.budgetCofi.finances[0].percentage;
          } else {
            row.erdfGrantRate = 0;
          }
          // row.partnerErdfBudget = row.partnerTECbudget * row.erdfGrantRate / 100;
          row.partnerErdfBudget = (element.funds[i] && element.funds[i].budgetPerFund[0] ? element.funds[i].budgetPerFund[0].value : 0);
          if (row.applyForAdvance === 'Yes' && row.partnerErdfBudget > 0 && partner.partnerSubType === 'MICRO_ENTERPRISE') {
            if ((row.partnerErdfBudget / 2) > 50000) {
              row.calculMagique = 50000;
            } else {
              row.calculMagique = row.partnerErdfBudget / 2;
            }
          } else {
            row.calculMagique = 0;
          }
        } else {
          row.erdfGrantRate = 0;
          row.partnerErdfBudget = 0;
          row.calculMagique = 0;
        }
        row.attachments = partner.attachments.length > 0 ? partner.attachments.length : 'No';
        row.attachmentsList = partner.attachments.map(attachment => attachment.name).join('; ');
        formattedDataStep2.push(row);
        console.log('row', row);
        i++;
      }
    }
    formattedDataStep2.sort((a, b) => a.customIdentifier < b.customIdentifier ? -1 : 1);
    //console.warn(formattedDataStep2);
    return formattedDataStep2;
  }

  const convertDataToXlsxStep1Projects = (data) => {
    let formattedDataStep1Project = [];
    for (let element of data) {
      let lp;
      for (let partner of element.partners) {

        if (partner.role === 'LEAD_PARTNER') {
          lp = partner;
          break;
        }
      }
      //console.log(lp);
      let row = {};
      row.callName = element.callName;
      row.customIdentifier = element.customIdentifier;
      row.status = formatUpperCaseString(element.projectStatus);
      row.acronym = element.acronym;
      if (element.details.title[0]) row.title = element.details.title[0].translation;
      if (element.details.intro[0]) row.summary = element.details.intro[0].translation;
      row.duration = element.details.duration;
      row.priority = element.programmePriorityCode;
      row.specificObjectiveCode = element.specificObjectiveCode;
      if (lp) {
        row.lpName = lp.nameInEnglish;
        if (lp.addresses[0]) {
          row.country = lp.addresses[0].country;
          row.nuts2 = lp.addresses[0].nutsRegion2;
          row.nuts3 = lp.addresses[0].nutsRegion3;
        } else {
          row.country = '';
          row.nuts2 = '';
          row.nuts3 = '';
        }
      } else {
        row.lpName = '';
        row.country = '';
        row.nuts2 = '';
        row.nuts3 = '';
      }
      row.projectTec = element.details.budgetTotal;
      row.projectErdf = element.details.budgetErdfTotal;
      row.percentInvestment = element.details.percentBudgetInvestments;
      row.applicantName = element.applicant.name + ' ' + element.applicant.surname;
      row.applicantEmail = element.applicant.email;
      row.attachments = element.attachments.length > 0 ? element.attachments.length : 'No';
      row.attachmentsList = element.attachments.map(attachment => attachment.name).join('; ');
      formattedDataStep1Project.push(row);
    }
    formattedDataStep1Project.sort((a, b) => a.customIdentifier < b.customIdentifier ? -1 : 1);
    //console.log(formattedDataStep1);
    return formattedDataStep1Project;
  }

  function formatDate(date) {
    return date.split('-')[2] + '/' + date.split('-')[1] + '/20' + date.split('-')[0];
  }

  const convertDataToXlsxStep2Projects = (data) => {
    let formattedDataStep2Project = [];
    for (let element of data) {
      let lp;
      for (let partner of element.partners) {
        if (partner.role === 'LEAD_PARTNER') {
          lp = partner;
          break;
        }
      }
    //  console.log('convertDataToXlsxStep2Projects', element.contractMonitoringPeriods);
      let row = {};
      row.callName = element.callName;
      row.customIdentifier = element.customIdentifier;
      row.status = formatUpperCaseString(element.projectStatus);
      row.acronym = element.acronym;
      if (element.details.title[0]) row.title = element.details.title[0].translation;
      if (element.details.intro[0]) row.summary = element.details.intro[0].translation;
      const monitPeriods = element.contractMonitoringPeriods
      if (monitPeriods?.length > 0) row.projectStartDate = monitPeriods[0].startDate ? formatDate(monitPeriods[0].startDate) : ''; else row.projectStartDate = '';
      if (monitPeriods?.length > 0) row.projectEndDate = monitPeriods[monitPeriods.length - 1].endDate ? formatDate(monitPeriods[monitPeriods.length - 1].endDate) : ''; else row.projectEndDate = '';
      row.duration = element.details.duration;
      row.priority = element.programmePriorityCode;
      row.specificObjectiveCode = element.specificObjectiveCode;
      if (lp) {
        row.lpName = lp.nameInEnglish;
        if (lp.addresses[0]) {
          row.country = lp.addresses[0].country;
          row.nuts2 = lp.addresses[0].nutsRegion2;
          row.nuts3 = lp.addresses[0].nutsRegion3;
        } else {
          row.country = '';
          row.nuts2 = '';
          row.nuts3 = '';
        }
      } else {
        row.lpName = '';
        row.country = '';
        row.nuts2 = '';
        row.nuts3 = '';
      }
      if (element.cofinancing) {
        row.projectTec = element.cofinancing.projectManagementCoFinancing.totalFundAndContribution;
        row.projectErdf = element.cofinancing.projectManagementCoFinancing.totalEuFundingAmount;
        row.grantrate = element.cofinancing.projectManagementCoFinancing.averageCoFinancingRate;
      } else {
        row.projectTec = 0;
        row.projectErdf = 0;
        row.grantrate = 0;
      }
      row.applicantName = element.applicant.name + ' ' + element.applicant.surname;
      row.applicantEmail = element.applicant.email;
      row.attachments = element.attachments.length > 0 ? element.attachments.length : 'No';
      row.attachmentsList = element.attachments.map(attachment => attachment.name).join('; ');
      formattedDataStep2Project.push(row);
    }
    formattedDataStep2Project.sort((a, b) => a.customIdentifier < b.customIdentifier ? -1 : 1);
    return formattedDataStep2Project;
  }

  const convertDataToXlsxStep1Summaries = (data) => {
    let formattedDataStep1Summaries = [];
    for (let element of data) {
      let lp;
      for (let partner of element.partners) {
        if (partner.role === 'LEAD_PARTNER') {
          lp = partner;
          break;
        }
      }
      //console.log(lp);
      let row = {};
      row.callName = element.callName;
      row.customIdentifier = element.customIdentifier;
      row.status = formatUpperCaseString(element.projectStatus);
      row.acronym = element.acronym;
      if (element.details.title[0]) row.title = element.details.title[0].translation;
      if (element.details.intro[0]) row.summary = element.details.intro[0].translation;
      row.summaryFrench = element.details.summaryFR;
      row.summaryGerman = element.details.summaryDE;
      row.summaryDutch = element.details.summaryNL;
      row.duration = element.details.duration;
      row.priority = element.programmePriorityCode;
      row.specificObjectiveCode = element.specificObjectiveCode;
      if (lp) {
        row.lpName = lp.nameInEnglish;
        if (lp.addresses[0]) {
          row.country = lp.addresses[0].country;
        } else {
          row.country = '';
        }
      } else {
        row.lpName = '';
        row.country = '';
      }
      formattedDataStep1Summaries.push(row);
    }
    formattedDataStep1Summaries.sort((a, b) => a.customIdentifier < b.customIdentifier ? -1 : 1);
    //console.log(formattedDataStep1);
    return formattedDataStep1Summaries;
  }

  const convertDataToXlsxStep2Summaries = (data) => {
    let formattedDataStep2Summaries = [];
    for (let element of data) {
      let lp;
      for (let partner of element.partners) {
        if (partner.role === 'LEAD_PARTNER') {
          lp = partner;
          break;
        }
      }
      //console.log(lp);
      let row = {};
      row.callName = element.callName;
      row.customIdentifier = element.customIdentifier;
      row.status = formatUpperCaseString(element.projectStatus);
      row.acronym = element.acronym;
      if (element.details.title[0]) row.title = element.details.title[0].translation;
      if (element.details.intro[0]) row.summary = element.details.intro[0].translation;
      row.summaryFrench = element.details.summaryFR;
      row.summaryGerman = element.details.summaryDE;
      row.summaryDutch = element.details.summaryNL;
      row.duration = element.details.duration;
      row.priority = element.programmePriorityCode;
      row.specificObjectiveCode = element.specificObjectiveCode;
      if (lp) {
        row.lpName = lp.nameInEnglish;
        if (lp.addresses[0]) {
          row.country = lp.addresses[0].country;
        } else {
          row.country = '';
        }
      } else {
        row.lpName = '';
        row.country = '';
      }
      if (element.cofinancing) {
        row.projectTec = element.cofinancing.projectManagementCoFinancing.totalFundAndContribution;
        row.projectErdf = element.cofinancing.projectManagementCoFinancing.totalEuContribution;
      } else {
        row.projectTec = 0;
        row.projectErdf = 0;
      }
      formattedDataStep2Summaries.push(row);
    }
    formattedDataStep2Summaries.sort((a, b) => a.customIdentifier < b.customIdentifier ? -1 : 1);
    //console.log(formattedDataStep1);
    return formattedDataStep2Summaries;
  }

  const convertDataToXlsxSolvencyCheck = (data) => {

    let formattedDataSolvency = [];

    for (let element of data) {
      let solvencyComponents = [];
      const projectSolvency1 = element.checklistDetail.find(checklist => checklist.name === appState.solvencyChecklist1);
      let solvency1components = [];
      if (projectSolvency1) solvency1components = projectSolvency1.detail.components
      solvency1components = solvency1components.slice().sort((a, b) => a.position - b.position);
      solvency1components.shift();
      solvencyComponents = solvencyComponents.concat(solvency1components);
      if (element.partners.length > 12) {
        const projectSolvency2 = element.checklistDetail.find(checklist => checklist.name === appState.solvencyChecklist2);
        let solvency2components = [];
        if (projectSolvency2) solvency2components = projectSolvency2.detail.components;
        solvency2components = solvency2components.slice().sort((a, b) => a.position < b.position ? -1 : 1);
        solvencyComponents = solvencyComponents.concat(solvency1components);
      }

      //console.error(solvencyComponents);

      let filteredComponents = [];
      let partnerNumber = 0;
      try {
        for (let i = 0; i < solvencyComponents.length; i++) {
          if (solvencyComponents[i + 1] && (solvencyComponents[i].type === 'HEADLINE' && solvencyComponents[i + 1].type === 'OPTIONS_TOGGLE') && partnerNumber < element.partners.length) {
            partnerNumber++;
            let component = {};
            // Debug V6.0.5
            //if (!solvencyComponents[i + 1].instanceMetadata){ appState.error = true; appState.msgAlert = 'erreur Solvency Check Dossier N° '+element.customIdentifier }

            component.documentationRequired = solvencyComponents[i + 1].instanceMetadata.answer;

            if (solvencyComponents[i + 2].instanceMetadata.answer === 'Yes/Yes: The document is here, the quality is sufficient') {
              component.financialStatementN2 = 'Validated';
            } else if (solvencyComponents[i + 2].instanceMetadata.answer === 'Yes/No: The document is here, the quality is not sufficient') {
              component.financialStatementN2 = 'Insufficient';
            } else {
              component.financialStatementN2 = solvencyComponents[i + 2].instanceMetadata.answer;
            }

            if (solvencyComponents[i + 3].instanceMetadata.answer === 'Yes/Yes: The document is here, the quality is sufficient') {
              component.financialStatementN1 = 'Validated';
            } else if (solvencyComponents[i + 3].instanceMetadata.answer === 'Yes/No: The document is here, the quality is not sufficient') {
              component.financialStatementN1 = 'Insufficient';
            } else {
              component.financialStatementN1 = solvencyComponents[i + 3].instanceMetadata.answer;
            }

            if (solvencyComponents[i + 4].instanceMetadata.answer === 'Yes/Yes: The document is here, the quality is sufficient') {
              component.kbis = 'Validated';
            } else if (solvencyComponents[i + 4].instanceMetadata.answer === 'Yes/No: The document is here, the quality is not sufficient') {
              component.kbis = 'Insufficient';
            } else {
              component.kbis = solvencyComponents[i + 4].instanceMetadata.answer;
            }

            component.partnerNumber = partnerNumber;
            filteredComponents.push(component);
          }
        }
      }
      catch (e) {
        console.error(e);
        dispatch(setError('Erreur Solvency Check Dossier N° ' + element.customIdentifier));
      }
      let partners = element.partners;
      for (let partner of partners) {
        let legalRepresentative = {};
        let contactPerson = {};
        for (let contact of partner.contacts) {
          if (contact.type === 'LegalRepresentative') {
            legalRepresentative.fullName = '';
            if (contact.title) legalRepresentative.fullName += contact.title + ' ';
            if (contact.firstName) legalRepresentative.fullName += contact.firstName + ' ';
            if (contact.lastName) legalRepresentative.fullName += contact.lastName;
          }
          if (contact.type === 'ContactPerson') {
            contactPerson.fullName = '';
            if (contact.title) contactPerson.fullName += contact.title + ' ';
            if (contact.firstName) contactPerson.fullName += contact.firstName + ' ';
            if (contact.lastName) contactPerson.fullName += contact.lastName;
            contactPerson.email = contact.email;
            contactPerson.telephone = contact.telephone;
          }
        }
        let row = {};
        row.callName = element.callName;
        row.customIdentifier = element.customIdentifier;
        row.status = formatUpperCaseString(element.projectStatus);
        row.acronym = element.acronym;
        //if (element.details.title[0] !== undefined) row.title = element.details.title[0].translation;
        //row.priority = element.programmePriorityCode;
        //row.so = element.specificObjectiveCode;
        row.partnerNumber = partner.sortNumber;
        row.partnerName = partner.nameInEnglish;
        row.partnerAbbreviation = partner.abbreviation;
        row.role = formatUpperCaseString(partner.role);
        row.partnerType = formatCamelCaseString(partner.partnerType);
        //row.partnerSize = partner.partnerSubType;
        row.legalStatus = partner.legalStatusId === 1 ? 'Public' : 'Private';
        if (partner.addresses[0] !== undefined) {
          row.country = partner.addresses[0].country;
          row.nuts2 = partner.addresses[0].nutsRegion2;
        }
        //console.log(filteredComponents);
        if (filteredComponents.length > 0) {
          let partnerComponent = filteredComponents.find(component => component.partnerNumber === partner.sortNumber);
          if (partnerComponent) row.docRequired = partnerComponent.documentationRequired;
          if (partnerComponent) row.financialN2 = partnerComponent.financialStatementN2;
          if (partnerComponent) row.financialN1 = partnerComponent.financialStatementN1;
          if (partnerComponent) row.kbis = partnerComponent.kbis;
        }
        formattedDataSolvency.push(row);
      }
    }
    formattedDataSolvency.sort((a, b) => a.customIdentifier < b.customIdentifier ? -1 : 1);
    //console.log(formattedDataSolvency);
    return formattedDataSolvency;
  }

  const convertDataToXlsxSubmittedProjectsOverview = (data, callNumber, projectStatus) => {

    const totalBudget = 287481905;

    let formattedDataSubmittedProjectsOverview = [];
    let filteredData = []
    for (let status of projectStatus) {
      filteredData = filteredData.concat(data.filter(project => project.details.callSettings.callId === callNumber && project.projectStatus === status));
    }
    for (let element of filteredData) {
        let lp;
        for (let partner of element.partners) {
            if (partner.role === 'LEAD_PARTNER') {
            lp = partner;
            break;
            }
        }
        let row = {};
        row.projectNumber = element.customIdentifier;
        row.acronym = element.acronym;
        row.duration = element.details.duration;
        row.priority = element.programmePriorityCode;
        row.so = element.specificObjectiveCode;
        if (lp?.addresses) {
            if (!lp.addresses?.[0]) row.lpCountry = '';
            row.lpCountry = lp.addresses[0]?.country;
        } else {
            row.lpCountry = '';
        }
        if (element.cofinancing) {
            row.projectTec = element.cofinancing.projectManagementCoFinancing.totalFundAndContribution;
            row.projectErdf = element.cofinancing.projectManagementCoFinancing.totalEuFundingAmount;
            row.grantrate = element.cofinancing.projectManagementCoFinancing.averageCoFinancingRate;
        } else {
            row.projectTec = 0;
            row.projectErdf = 0;
            row.grantrate = 0;
        }
        formattedDataSubmittedProjectsOverview.push(row);
    }
    // Intermediate title line
    let row = {};
    row.projectNumber = '';
    row.acronym = 'Number of applications';
    row.duration = '';
    row.priority = 'Priority';
    row.so = 'S.O.';
    row.lpCountry = '';
    row.projectTec = '';
    row.projectErdf = '';
    row.grantrate = '';
    formattedDataSubmittedProjectsOverview.push(row);

    // Total calculation

    let listePriorite = [];
    // get all occurrences of element.priority
    for (let element of filteredData) {
      if (!listePriorite.includes(element.programmePriorityCode)) {
        listePriorite.push(element.programmePriorityCode);
      }
    }
    listePriorite.sort((a, b) => a < b ? -1 : 1);
    // get sum of projectTec, projectErdf for each priority
    for (let priorite of listePriorite) {
      let filteredDataByPriority = filteredData.filter(project => project.programmePriorityCode === priorite);
      let sumProjectTec = 0;
      let sumProjectErdf = 0;
      for (let element of filteredDataByPriority) {
        if (element.cofinancing) {
          sumProjectTec += element.cofinancing.projectManagementCoFinancing.totalFundAndContribution;
          sumProjectErdf += element.cofinancing.projectManagementCoFinancing.totalEuFundingAmount;
        }
      }
      row = {};
      row.projectNumber = '';
      row.acronym = '';
      row.duration = filteredDataByPriority.length;
      row.priority = priorite;
      row.so = '';
      row.lpCountry = '';
      row.projectTec = sumProjectTec;
      row.projectErdf = sumProjectErdf;
      row.grantrate = sumProjectErdf / sumProjectTec * 100;
      formattedDataSubmittedProjectsOverview.push(row);
    }

    let listeSo = [];
    for (let element of filteredData) {
      if (!listeSo.includes(element.specificObjectiveCode)) {
        listeSo.push(element.specificObjectiveCode);
      }
    }
    listeSo.sort((a, b) => a < b ? -1 : 1);
    // get sum of projectTec, projectErdf for each so
    for (let so of listeSo) {
      let filteredDataBySo = filteredData.filter(project => project.specificObjectiveCode === so);
      let sumProjectTec = 0;
      let sumProjectErdf = 0;
      for (let element of filteredDataBySo) {
        if (element.cofinancing) {
          sumProjectTec += element.cofinancing.projectManagementCoFinancing.totalFundAndContribution;
          sumProjectErdf += element.cofinancing.projectManagementCoFinancing.totalEuFundingAmount;
        }
      }
      row = {};
      row.projectNumber = '';
      row.acronym = '';
      row.duration = filteredDataBySo.length;
      row.priority = '';
      row.so = so;
      row.lpCountry = '';
      row.projectTec = sumProjectTec;
      row.projectErdf = sumProjectErdf;
      row.grantrate = sumProjectErdf / sumProjectTec * 100;
      formattedDataSubmittedProjectsOverview.push(row);
    }
    // get total sum of projectTec, projectErdf
    let sumProjectTec = 0;
    let sumProjectErdf = 0;
    for (let element of filteredData) {
      if (element.cofinancing) {
        sumProjectTec += element.cofinancing.projectManagementCoFinancing.totalFundAndContribution;
        sumProjectErdf += element.cofinancing.projectManagementCoFinancing.totalEuFundingAmount;
      }
    }

    row = {};
    row.projectNumber = '';
    row.acronym = '';
    row.duration = '';
    row.priority = '';
    row.so = '';
    row.lpCountry = 'TOTAL BUDGET REQUESTED';
    row.projectTec = sumProjectTec;
    row.projectErdf = sumProjectErdf;
    row.grantrate = sumProjectErdf / sumProjectTec * 100;
    formattedDataSubmittedProjectsOverview.push(row);

    row = {};
    row.projectNumber = '';
    row.acronym = '';
    row.duration = '';
    row.priority = '';
    row.so = '';
    row.lpCountry = '';
    row.projectTec = '';
    row.projectErdf = '';
    row.grantrate = '';
    formattedDataSubmittedProjectsOverview.push(row);

    row = {};
    row.projectNumber = '';
    row.acronym = '';
    row.duration = '';
    row.priority = '';
    row.so = '';
    row.lpCountry = 'TOTAL PROGRAMME BUDGET FOR PROJECTS';
    row.projectTec = '';
    row.projectErdf = totalBudget;
    row.grantrate = '';
    formattedDataSubmittedProjectsOverview.push(row);

    row = {};
    row.projectNumber = '';
    row.acronym = '';
    row.duration = '';
    row.priority = '';
    row.so = '';
    row.lpCountry = 'SHARE REQUESTED / TOTAL BUDGET';
    row.projectTec = '';
    row.projectErdf = sumProjectErdf / totalBudget * 100;
    row.grantrate = '';
    formattedDataSubmittedProjectsOverview.push(row);

    return { data: formattedDataSubmittedProjectsOverview, numbers: filteredData.length };
  }

  const convertDataToXlsProjectInvestments = (data) => {
    let formattedDataProjectInvestments = [];
    for (let element of data) {
      for (let workPackage of element.workPackages) {
        if (workPackage.investments) {
          for (let investment of workPackage.investments) {
            let row = {};
            row.callName = element.callName;
            row.customIdentifier = element.customIdentifier;
            row.status = formatUpperCaseString(element.projectStatus);
            row.acronym = element.acronym;
            row.specificObjectiveCode = element.specificObjectiveCode;
            row.investmentNumber = 'I' + workPackage.number + '.' + investment.investmentNumber;
            row.investmentTitle = investment.title[0]?.translation;
            row.location = investment.address?.region3;
            let costs = 0.0;
            for (let partner of element.partners) {
              for (let equipmentCost of partner.costs.equipmentCosts) {
                if (equipmentCost.investmentId === investment.id) {
                  costs += equipmentCost.rowSum;
                }
              }
              for (let externalCost of partner.costs.externalCosts) {
                if (externalCost.investmentId === investment.id) {
                  costs += externalCost.rowSum;
                }
              }
              for (let infrastructureCost of partner.costs.infrastructureCosts) {
                if (infrastructureCost.investmentId === investment.id) {
                  costs += infrastructureCost.rowSum;
                }
              }
            }
            //console.log(costs);
            row.costs = costs;
            formattedDataProjectInvestments.push(row);
          }
        }
      }
    }
    return formattedDataProjectInvestments;
  }

  const exportXlsxSubmittedProjectsOverview = (index, callStep) => {
    let workbook = XLSX.utils.book_new();

    const data = projectState.dataToExport[index].data;
    const numbers = projectState.dataToExport[index].numbers + 1;
    const secondeData = data.filter((item) => (item.priority && item.priority != '' && item.projectNumber === ''));

    let worksheet = XLSX.utils.json_to_sheet(data, { skipHeader: false });
    XLSX.utils.sheet_add_aoa(worksheet, [headersWs[index]]);
    XLSX.utils.book_append_sheet(workbook, worksheet, workSheets[index]);

    // Appliquer les styles aux différentes plages de cellules
    for (let col = 0; col < headersWs[index].length; col++) {
      // Plage de cellules pour les lignes paires avant la ligne "numbers"
      const range1 = {
        start: { row: 2, col },
        end: { row: data.length, col }
      };
      applyDefaultStyleToRange(worksheet, range1);
      for (let j = 2; j <= numbers; j++) {
        const cellId = cols[col] + j;
        if (!worksheet[cellId]) continue;

        if (j % 2 === 0) worksheet[cellId].s = { ...worksheet[cellId].s, ...styles.coloredLight };
      }

      // Plage de cellules pour les lignes de "secondeData"
      const range2 = {
        start: { row: numbers + 2, col },
        end: { row: numbers + secondeData.length, col }
      };
      applyColoredLightStyleToRange(worksheet, range2);

      // Plage de cellules pour les lignes après la ligne "secondeData"
      const range3 = {
        start: { row: numbers + secondeData.length + 1, col },
        end: { row: data.length - 3, col }
      };
      applyColoredStyleToRange(worksheet, range3);

      // Plage de cellules pour la ligne avant la dernière ligne
      const range4 = {
        start: { row: data.length - 2, col },
        end: { row: data.length - 2, col }
      };
      applyColoredDarkStyleToRange(worksheet, range4);

      // Plage de cellules pour les deux dernières lignes
      // worksheet[cols[col] + (numbers)]

      for (let j = data.length - 1; j <= data.length + 1; j++) {
        const cellId = cols[col] + j;
        if (!worksheet[cellId] || worksheet[cellId].v === '') continue;

        worksheet[cellId].s = { ...worksheet[cellId].s, ...styles.coloredDark };
      }

      worksheet['!merges'] = [
        { s: { r: data.length - 1, c: 5 }, e: { r: data.length - 1, c: 6 } },
        { s: { r: data.length, c: 5 }, e: { r: data.length, c: 6 } },
        { s: { r: numbers, c: 1 }, e: { r: numbers, c: 2 } }
      ];
    }

    worksheet['!cols'] = [
      { wch: 15 },
      { wch: 15 },
      { wch: 8 },
      { wch: 8 },
      { wch: 8 },
      { wch: 25 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 }
    ];
    worksheet['!rows'] = [
      { hpt: 30, hpx: 30 },
    ]

    data.forEach((row, i) => {
      worksheet['!rows'].push({ hpt: 18, hpx: 18 });
    });

    headersWs[index].forEach((col, i) => {
      const cellId = cols[i] + '1';
      if (!worksheet[cellId]) return;

      worksheet[cellId].s = { ...worksheet[cellId].s, ...styles.headerOverview };
    });

    stylesToApply[index].cols.forEach((col) => {
      for (let i = 2; i <= data.length + 2; i++) {
        const cellId = col + i;
        if (!worksheet[cellId]) return;

        worksheet[cellId].s = { ...worksheet[cellId].s, ...stylesToApply[index].style };
      }
    });

    financialStyles[index].cols.forEach((col) => {
      for (let i = 2; i <= data.length + 2; i++) {
        const cellId = col + i;
        if (!worksheet[cellId]) return;

        worksheet[cellId].s = { ...worksheet[cellId].s, ...financialStyles[index].style };
      }
    });

    const today = new Date().toISOString().slice(0, 10);
    const xlsBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([xlsBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8' });
    FileSaver.saveAs(dataBlob, callStep + workSheets[index] + '_' + today + '.xlsx');
  }

  const exportXlsxData = (index) => {
    let wb = XLSX.utils.book_new();
    //let i = 0;

    const data = projectState.dataToExport[index];
    console.log('exportXlsxData', index, data);
    //console.warn(data);

    //console.log(data);
    let ws = XLSX.utils.json_to_sheet(data, { skipHeader: false });
    XLSX.utils.sheet_add_aoa(ws, [headersWs[index]]);
    XLSX.utils.book_append_sheet(wb, ws, workSheets[index]);

    // Set default Cell style
    for (let i = 0; i < headersWs[index].length; i++) {
      for (let j = 2; j <= data.length + 1; j++) {
        const cellId = cols[i] + j;
        if (ws[cellId]) ws[cellId].s = styles.default;
      }
    }

    for (let k = 0; k <= headersWs[index].length; k++) {
      if (ws[cols[k] + '1']) {
        ws[cols[k] + '1'].s = styles.header;
      }
    }

    const styleToApply = stylesToApply[index];
    for (const col of styleToApply.cols) {
      for (let j = 2; j <= data.length + 2; j++) {
        if (ws[col + j]) ws[col + j].s = styleToApply.style;
      }
    }
    const financialStyle = financialStyles[index];
    //console.warn(financialStyle);
    for (const col of financialStyle.cols) {
      for (let j = 2; j <= data.length + 2; j++) {
        if (ws[col + j]) ws[col + j].s = financialStyle.style;
      }
    }

    const today = new Date().toISOString().slice(0, 10);
    const xlsBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([xlsBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8' });
    FileSaver.saveAs(dataBlob, workSheets[index] + "_" + today + '.xlsx');
  }

  // Export Excel des investissements projets non inclus dans l'export global

  const exportXlsxProjectInvestments = (data) => {
    const workSheetName = 'Project investments';
    const headersWsInvest = [
      'Call number',
      'Project number',
      'Project status',
      'Acronym',
      'S.O',
      'Investment number',
      'Investment title',
      'Investment location',
      'Total costs'
    ];
    let workbook = XLSX.utils.book_new();
    let worksheet = XLSX.utils.json_to_sheet(data, { skipHeader: false });
    XLSX.utils.sheet_add_aoa(worksheet, [headersWsInvest]);
    XLSX.utils.book_append_sheet(workbook, worksheet, workSheetName);

    // Set default Cell style
    for (let i = 0; i < headersWsInvest.length; i++) {
      for (let j = 2; j <= data.length + 1; j++) {
        const cellId = cols[i] + j;
        if (worksheet[cellId]) worksheet[cellId].s = styles.default;
      }
    }

    for (let k = 0; k <= headersWsInvest.length; k++) {
      if (worksheet[cols[k] + '1']) {
        worksheet[cols[k] + '1'].s = styles.header;
      }
    }

    const styleToApply = { cols: ['E', 'F'], style: styles.center };
    for (const col of styleToApply.cols) {
      for (let j = 2; j <= data.length + 2; j++) {
        if (worksheet[col + j]) worksheet[col + j].s = styleToApply.style;
      }
    }

    const financialStyle = { cols: ['I'], style: styles.financial };
    for (const col of financialStyle.cols) {
      for (let j = 2; j <= data.length + 2; j++) {
        if (worksheet[col + j]) worksheet[col + j].s = financialStyle.style;
      }
    }

    const today = new Date().toISOString().slice(0, 10);
    const xlsBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([xlsBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8' });
    FileSaver.saveAs(dataBlob, workSheetName + "_" + today + '.xlsx');
  }


  // Appliquer un style à une plage de cellules
  const applyStyleToRange = (worksheet, range, style) => {
    for (let row = range.start.row; row <= range.end.row; row++) {
      for (let col = range.start.col; col <= range.end.col; col++) {
        const cellId = cols[col] + row;
        if (!worksheet[cellId]) continue;
        worksheet[cellId].s = { ...worksheet[cellId].s, ...style };
      }
    }
  };

  // Appliquer le style par défaut à la plage de cellules donnée
  const applyDefaultStyleToRange = (worksheet, range) => {
    applyStyleToRange(worksheet, range, styles.default);
  };

  // Appliquer le style "coloredLight" à la plage de cellules donnée
  const applyColoredLightStyleToRange = (worksheet, range) => {
    applyStyleToRange(worksheet, range, styles.coloredLight);
  };

  // Appliquer le style "colored" à la plage de cellules donnée
  const applyColoredStyleToRange = (worksheet, range) => {
    applyStyleToRange(worksheet, range, styles.colored);
  };

  // Appliquer le style "coloredDark" à la plage de cellules donnée
  const applyColoredDarkStyleToRange = (worksheet, range) => {
    applyStyleToRange(worksheet, range, styles.coloredDark);
  };

  return (
    <div>
      <Modal
        dimmer='blurring'
        closeOnDimmerClick={false}
        onClose={() => dispatch(showMenuXLS(false))}
        onOpen={() => dispatch(showMenuXLS(true))}
        open={appState.menuXLSVisible}
        size='large'
      >
        <Modal.Content>
          <Modal.Description>
            {appState.error ? <Message negative><p>{appState.msgError}</p> </Message> : null}
            <h3>Please select a report to generate</h3>
          </Modal.Description>
          <Grid columns={3}>
            <Grid.Column>
              <List divided relaxed>
                <ListHeader as='h4'>Step 1</ListHeader>
                <List.Item>
                  <List.Content>
                    <Label color='green' ribbon>XLS</Label>
                    <List.Header as='a' onClick={() => exportXlsxData(0)}>Step 1 All partners</List.Header>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <Label color='green' ribbon>XLS</Label>
                  <List.Content>
                    <List.Header as='a' onClick={() => exportXlsxData(2)}>Step 1 Projects</List.Header>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <Label color='green' ribbon>XLS</Label>
                  <List.Content>
                    <List.Header as='a' onClick={() => exportXlsxData(4)}>Step 1 Summaries</List.Header>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <Label color='green' ribbon>XLS</Label>
                  <List.Content>
                    <List.Header as='a' onClick={() => exportXlsxSubmittedProjectsOverview(7, 'CALL1_STEP1_')}>Call 1 Step 1 Overview of Submitted Projects</List.Header>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <Label color='green' ribbon>XLS</Label>
                  <List.Content>
                    <List.Header as='a' onClick={() => exportXlsxSubmittedProjectsOverview(9, 'CALL2_STEP1_')}>Call 2 Step 1 Overview of Submitted Projects</List.Header>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <Label color='green' ribbon>XLS</Label>
                  <List.Content>
                    <List.Header as='a' onClick={() => exportXlsxSubmittedProjectsOverview(12, 'CALL4_STEP1_')}>Call 4 Step 1 Overview of Submitted Projects</List.Header>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <Label color='green' ribbon>XLS</Label>
                  <List.Content>
                    <List.Header as='a' onClick={() => exportXlsxSubmittedProjectsOverview(14, 'CALL5_STEP1_')}>Call 5 Step 1 Overview of Submitted Projects</List.Header>
                  </List.Content>
                </List.Item>
              </List>
            </Grid.Column>
            <Grid.Column>
              <List divided relaxed>
                <ListHeader as='h4'>Step 2</ListHeader>
                <List.Item>
                  <Label color='green' ribbon>XLS</Label>
                  <List.Content>
                    <List.Header as='a' onClick={() => exportXlsxData(1)}>Step 2 All partners</List.Header>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <Label color='green' ribbon>XLS</Label>
                  <List.Content>
                    <List.Header as='a' onClick={() => exportXlsxData(3)}>Step 2 Projects</List.Header>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <Label color='green' ribbon>XLS</Label>
                  <List.Content>
                    <List.Header as='a' onClick={() => exportXlsxData(5)}>Step 2 Summaries</List.Header>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <Label color='green' ribbon>XLS</Label>
                  <List.Content>
                    <List.Header as='a' onClick={() => exportXlsxSubmittedProjectsOverview(8, 'CALL1_STEP2_')}>Call 1 Step 2 Overview of Submitted Projects</List.Header>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <Label color='green' ribbon>XLS</Label>
                  <List.Content>
                    <List.Header as='a' onClick={() => exportXlsxSubmittedProjectsOverview(10, 'CALL2_STEP2_')}>Call 2 Step 2 Overview of Submitted Projects</List.Header>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <Label color='green' ribbon>XLS</Label>
                  <List.Content>
                    <List.Header as='a' onClick={() => exportXlsxSubmittedProjectsOverview(11, 'CALL3_STEP2_')}>Call 3 Step 2 Overview of Submitted Projects</List.Header>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <Label color='green' ribbon>XLS</Label>
                  <List.Content>
                    <List.Header as='a' onClick={() => exportXlsxSubmittedProjectsOverview(13, 'CALL4_STEP2_')}>Call 4 Step 2 Overview of Submitted Projects</List.Header>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <Label color='green' ribbon>XLS</Label>
                  <List.Content>
                    <List.Header as='a' onClick={() => exportXlsxSubmittedProjectsOverview(15, 'CALL5_STEP2_')}>Call 5 Step 2 Overview of Submitted Projects</List.Header>
                  </List.Content>
                </List.Item>
              </List>
            </Grid.Column>

            <Grid.Column>
              <List divided relaxed>
                <ListHeader as='h4'>Other</ListHeader>
                <List.Item>
                  <Label color='green' ribbon>XLS</Label>
                  <List.Content>
                    <List.Header as='a' onClick={() => exportXlsxData(6)}>Solvency check</List.Header>
                  </List.Content>
                </List.Item>
              </List>
            </Grid.Column>

          </Grid>
          {/* ['Step 1 All partners', 'Step 2 All partners', 'Step 1 Projects', 'Step 2 Projects', 'Step 1 summaries', 'Step 2 summaries', 'Solvency Check']; */}



        </Modal.Content>
        <Modal.Actions>
          <Button color='black' onClick={() => dispatch(showMenuXLS(false))}>
            Cancel
          </Button>
        </Modal.Actions>
      </Modal>

      <Grid>
        <Grid.Column width={10}>
          <Input
            textAlign='center'
            placeholder='Search project Identifier'
            value={appState.searchValue}
            onChange={onSearchChange}
            onKeyPress={handleKeyPress}
            action={{ color: 'blue', icon: 'search', onClick: () => onSearch(appState.searchValue) }}
          />
        </Grid.Column>

        <Grid.Column width={2}>
          {/*((appState.role === 'JS officer +' || appState.role === 'administrator') && !appState.jems32) ? <a href='http://jemsreports.iesi.ovh:3000/' target='_blank' rel='noopener noreferrer'> <Button icon color='blue' labelPosition='right'>*/}
          {(!appState.jems32) ? <a href='http://jemsreports.iesi.ovh:3000/' target='_blank' rel='noopener noreferrer'> <Button icon color='blue' labelPosition='right'>
            <Icon name='paper plane outline' />
            Go to Jems 32
          </Button>
          </a>
            : undefined
          }
        </Grid.Column>

        <Grid.Column width={2}>
          {((appState.role.toLowerCase() === 'js officer +' || appState.role.toLowerCase() === 'administrator' || appState.role.toLowerCase() === 'js') && !appState.loading) ? <Button icon color='green' onClick={() => getAllData()} labelPosition='right'>
            <Icon name='file excel outline' />
            Export Excel
          </Button>
            : undefined}
          {appState.loading ? <div><Label basic color='blue' pointing='below'>Please wait while we're collecting data, it's time to take a coffee <Icon name='coffee' /></Label><Progress percent={appState.avancement} progress color='blue' /> </div> : undefined}
        </Grid.Column>

        <Grid.Column width={2}>
          {((appState.role.toLowerCase() === 'js officer +' || appState.role.toLowerCase() === 'administrator' || appState.role.toLowerCase() === 'js') && !appState.loading) ? <Button icon color='green' onClick={() => exportProjectInvestments()} labelPosition='right'>
            <Icon name='file excel outline' />
            Projects Investments
          </Button>
            : undefined}
          {/* {appState.loading ? <div><Label basic color='blue' pointing='below'>Please wait while we're collecting some data from Jems <Icon name='clock outline' /></Label><Progress percent={appState.avancement} progress color='blue' /> </div> : undefined} */}
        </Grid.Column>

      </Grid>
    </div>
  );
}

export default Recherche;
